import { useContext } from "react";
import Viewport from "./viewport/viewport";
import styles from "./app-layout.module.css";
import {
  NeonSkyContext,
  NeonSkyFeatureFlag,
} from "lib/neon-sky/neon-sky-provider";
import { useGetUserNavCapabilitiesQuery } from "types/generated/operations";
import Header from "./header";
import Sidebar from "./sidebar";
import Sidebar1J from "./sidebar/sidebar-site-nav-1j";
import Footer from "./footer";
import { ViewContextProvider } from "./header/context/view-context-provider";

const {
  appLayout,
  appLayoutWithoutHeader,
  sidebar,
  sidebarSiteNav,
  header,
  viewport,
  footer,
} = styles;

export default function AppLayout(): JSX.Element {
  /*
   * TODO: investigate performance of blocking w/await
   * to ensure this isn't delayed in the event loop
   * (out of scope, 6/27/22, @leland)
   */
  const { data, loading } = useGetUserNavCapabilitiesQuery();
  const { featureFlags } = useContext(NeonSkyContext);

  if (loading || !data) return <></>;

  const globalNewNavFeatureFlagValue = Boolean(
    featureFlags[NeonSkyFeatureFlag.GLOBAL_NEW_NAV]
  );
  const isGlobalNewNav = globalNewNavFeatureFlagValue;

  const sidebarSectionClassName = isGlobalNewNav ? sidebarSiteNav : sidebar;

  const layoutClassName = [
    appLayout,
    isGlobalNewNav ? appLayoutWithoutHeader : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <>
      <div className={layoutClassName}>
        <section className={sidebarSectionClassName}>
          {isGlobalNewNav ? <Sidebar1J /> : <Sidebar />}
        </section>
        {!isGlobalNewNav && (
          <section className={header}>
            <ViewContextProvider>
              <Header capabilities={data.authenticatedMember.capabilities} />
            </ViewContextProvider>
          </section>
        )}
        <section className={viewport}>
          <Viewport />
        </section>
        <section className={footer}>
          <Footer />
        </section>
      </div>
    </>
  );
}
